const CalculatorIcon = () => {
    return <i className="fa-solid fa-calculator"></i>
}

export default CalculatorIcon;